<template>
  <v-container class="pt-3 pb-6 px-6">

    <!-- Floating Button -->
    <floating-button @click="createUser()" v-if="authUser"/>

    <!-- Confirmation -->
    <confirmation
      v-if="authUser"
      v-model="dialog"
      title="Eliminar Usuario"
      text="Desea eliminar el Usuario"
      :item="itemToDelete.userName"
      @close="dialog = false"
      @confirm="deleteUser()"
    />

    <!-- Page Header -->
    <page-header
      title="Usuarios"
      icon="mdi-account-multiple"
      divider="-"
      :breadcrumbs="breadcrumbs.items"
      refresh
      @refresh="loadUsers()"
    ></page-header>

    <!-- Loading Bar -->
    <v-progress-linear
      indeterminate
      v-if="isLoadingData"
    ></v-progress-linear>
    <!-- Table -->
    <v-data-table
      v-if="authUser"
      :headers="headers"
      :items="filteredRoles"
      :items-per-page="5"
      :search="search"
      class="elevation-1 mt-3"
      :footer-props="{
        'items-per-page-options': [5, 15, 30, 50]
      }"
    >
      <!-- No Data -->
      <template v-slot:no-data>
        No hay elementos
      </template>
      <!-- No Results -->
      <template v-slot:no-results>
        No hay elementos
      </template>
      <!-- Top -->
      <template v-slot:top>
        <v-toolbar flat color="white">
          <!-- State Filter -->
          <v-select
            v-model="filterState"
            :items="stateItems"
            label="Activo / Inactivo"
            class="shrink mr-5"
            clearable
            hide-details
            single-line
          ></v-select>
          <!-- Role Filter -->
          <v-autocomplete
            v-model="filterRole"
            :items="roleList"
            item-text="name"
            item-value="id"
            label="Rol"
            class="grow mr-5"
            clearable
            single-line
            hide-details
          ></v-autocomplete>
          <!-- Input Filter -->
          <v-text-field
            v-model="search"
            prepend-icon="mdi-account-search"
            label="Buscar..."
            class="grow"
            clearable
            hide-details
            single-line
          ></v-text-field>
        </v-toolbar>
      </template>
      <!-- Action -->
      <template v-slot:item.action="{ item }">
        <v-icon class="mr-2" @click="editUser(item)">mdi-account-edit</v-icon>
        <v-icon @click="showDeleteConfirmDialog(item)">mdi-delete</v-icon>
      </template>
      <!-- State -->
      <template v-slot:item.isActive="{ item }">
        <v-row justify="center" align="center" align-center>
          <v-chip
            class="white--text"
            :color="item.isActive ? 'primary' : 'deep-orange'"
          >{{ item.isActive ? 'Activo' : 'Inactivo' }}</v-chip>
        </v-row>
      </template>
      <!-- Roles -->
      <template v-slot:item.roles="{ item }">
        <v-chip class="ma-1" v-for="r in item.roles" v-bind:key="r.id" light>{{ r.name }}</v-chip>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import FloatingButton from "@/components/FloatingButton";
import Confirmation from "@/components/Confirmation";
import PageHeader from "@/components/PageHeader";
import { RolesRepository } from "@/api/Repositories";
import Util from "@/util/index";

export default {
  components: {
    FloatingButton,
    Confirmation,
    PageHeader
  },
  data: () => ({
    authUser: false,
    roleList: [],
    search: "",
    filterRole: '',
    filterState: null,
    stateItems: [
      {
        text: 'Activo',
        value: 'true'
      },
      {
        text: 'Inactivo',
        value: 'false'
      }
    ],
    isLoadingData: false,
    breadcrumbs: {
      items: [
        {
          text: "Configuración",
          disabled: true
        },
        {
          text: "Usuarios",
          disabled: true
        }
      ]
    },
    headers: [
      {
        text: "Documento de identidad",
        value: "documentId",
        align: "center"
      },
      { text: "Usuario", value: "userName", align: "center" },
      { text: "Nombre", value: "fullName", align: "center" },
      { text: "Rol(es)", value: "roles", align: "center", sortable: false },
      { text: "Estado", value: "isActive", align: "center" },
      { text: "Acciones", value: "action", sortable: false, align: "center" }
    ],
    dialog:  false,
    itemToDelete: {},
  }),
  // Computed properties
  computed: {
    users () {
      return this.$store.state.users.all
    },
    filteredState () {
      return this.filterState
        ? this.users.filter(element => {
          return element.isActive.toString().includes(this.filterState)
        }) :  this.users
    },
    filteredRoles () {
      return this.filterRole
        ? this.filteredState.filter(element => {
            return element.roles.some(element => {
              return element.id === this.filterRole
            })
          }) : this.filteredState
    },
  },
  // Methods
  methods: {
    loadUsers() {
      this.isLoadingData = true;
      RolesRepository.getAll().then(res => (this.roleList = res.data.data));
      this.$store
        .dispatch("users/getAllUsers")
        .then(() => {
          this.authUser = true
        })
        .catch(error => {
          if (error.response.status === 403 ) {
            this.$toast("Su perfil de usuario no tiene los permisos suficientes para acceder a esta funcionalidad del sistema.", {
              color: "error",
              x: "center",
              y: "top",
              icon: "mdi-information",
              timeout: 0,
              showClose: true,
              closeText: "Cerrar"
            });
            this.$router.push({ name: 'home'})
          } else {
            var errorToastMessage = "Ha ocurrido un error cargando los usuarios."
            Util.showErrorToast(this, error, errorToastMessage);
          }
        })
        .finally(() => {
          this.isLoadingData = false;
        });
    },
    showDeleteConfirmDialog(user) {
      this.dialog = true;
      this.itemToDelete = user;
    },
    createUser () {
      this.$router.push({ name: 'user-create' })
    },
    deleteUser() {
      this.$store
        .dispatch("users/deleteUser", this.itemToDelete.id)
        .then(() => {
          this.$toast("Usuario borrado correctamente.", {
            color: "success",
            x: "center",
            y: "top",
            icon: "mdi-information"
          });
          this.loadUsers()
        })
        .catch(error => {
          var errorToastMessage = "Ha ocurrido un error eliminando el usuario."
          Util.showErrorToast(this, error, errorToastMessage);
        })
        .finally(() => {
          this.dialog = !this.dialog
        })
    },
    editUser(user) {
      this.$router.push({
        name: "user-edit",
        params: { id: user.id }
      });
    }
  },

  // Lifecycle hooks
  created() {
    this.loadUsers();
  }
};
</script>

